export const dataHooks = {
  gallery: {
    modal: dataHook => {
      return `gallery-modal.${dataHook}`;
    },
    image: dataHook => {
      return `gallery-modal.${dataHook}.image`;
    },
    nextButton: dataHook => {
      return `gallery-modal.${dataHook}.next-button`;
    },
    previousButton: dataHook => {
      return `gallery-modal.${dataHook}.previous-button`;
    },
    dotNavigation: dataHook => {
      return `gallery-modal.${dataHook}.dot-navigation`;
    }
  }
};
//# sourceMappingURL=dataHooks.js.map